import { type CarrierDef } from '../common.js'
import { apiKey, username } from '../internal.js'

const credentialTypes = [username, apiKey] as const

export type dlwiCredType = (typeof credentialTypes)[number]
export const dlwi: CarrierDef<dlwiCredType> = {
  name: 'TForce Worldwide',
  scac: 'dlwi',
  credentialTypes,
  legacyCredMap: [
    ['username', 'username'],
    ['api-key', 'password'],
  ],
  engineLayers: ['rating', 'pickup', 'tracking'],
}
